// import AppLogo from "../../../Icons/logos/App-logo.png";
// import iconShow from "../../../Icons/icons-charcoal-dark/eye-show.png";
// import iconDone from "../../../Icons/icons-charcoal-dark/done.png";
import iconStar from "../../../Icons/icons-yellow/star.png";
import iconViews from "../../../Icons/icons-charcoal-dark/views.png";
import iconWhiteViews from "../../../Icons/icons-white/views.png";
import iconBlackViews from "../../../Icons/icons-black/views.png";
import iconWhiteWhatsApp from "../../../Icons/icons-white/whatsapp.png";
import iconShares from "../../../Icons/icons-white/share.png";
import iconAhead from "../../../Icons/icons-green/ahead.png";
import iconYellowAhead from "../../../Icons/NV/yellow/ahead.png";
import iconGreenAhead from "../../../Icons/icons-green/ahead.png";
import moreImg1 from "../../../Icons/icons-black/1-more-images-black.png";
import moreImg2 from "../../../Icons/icons-black/2-more-images-black.png";
import moreImg3 from "../../../Icons/icons-black/3-more-images-black.png";
import moreImg4 from "../../../Icons/icons-black/4-more-images-black.png";
import moreImg5 from "../../../Icons/icons-black/5-more-images-black.png";
import moreImg6 from "../../../Icons/icons-black/6-more-images-black.png";
import firebase from "../firebase";
import displayListing from "./display-listing";
import iconVerified from "../../../Icons/icons-white/verified.png";
import iconMAIVerified from "../../../Icons/icons-SM/MAI-VERIFIED.png";
import iconDotsMenu from "../../../Icons/icons-white/dots-menu.png";

import iconHomeCatVideos from "../../../Icons/icons-home-catagory/videos.png";
import logoBusiness from "../../../Icons/logos/empresa.png";

import GENRALHELPERS from "../GENRAL-HELPERS";

import iconRedDelete from "../../../Icons/NV/red/delete.png";
import iconRedEdit from "../../../Icons/NV/yellow/edit.png";






// import { title } from "process";

//
// style="background: #${colors.}; color: #${colors.};"

//













class GenarateHtml {
  _generateBusinessRewiewStars(number, reviews, data) {
    // TODO for now in use. Need to develop a rating system

    if (data.verifiedBusiness) {
      return ` 
      <div class="RatingStarCon2">
        <img class="" height="12px" src="${iconVerified}" alt=""/>
        <div class="BusinessEditorBusinessHeaderVerifiedBadgeText">verificado de Mercado MAI</div>
      </div>
       `;
    }
    return ``;
    let starHtml = ``;
    const stars = Math.round(number);
    if (stars === 0) {
      starHtml += `<img style="height: 10px;" src="${iconStar}" alt="">`;
    } else {
      for (let i = 0; i < stars; i++) {
        starHtml += `<img style="height: 10px;" src="${iconStar}" alt="">`;
      }
    }
    // <div class="RatingStarReviewText">
    //   ${reviews} calificaciones
    // </div>
    return `<div class="RatingStarCon1">
    <div class="RatingStarCon2">
      <div class="RatingStarRatedAtNumber">
        ${number}
      </div>
      <div class="RatingStarCon3">
        ${starHtml}
      </div>
    </div>

  </div>`;
  }
  _businessPackOfPacks(html) {
    return `
    <div class="BusinessesPackOfPacksDisplayCon1">${html}</div>
    `;
  }
  _businessPack(title, id, colors) {
    return `
  <div class="BusinessesPackDisplayCon1">
    <div class="BusinessesPackDisplayCon2">
      <div  style="color: #${colors.packTitles};" class="BusinessesPackDisplayTitle">
        ${title}
      </div>
      <div data-generall="expandforviewallbusiness" class="BusinessesPackDisplayVerTodo">
        Ver mas
      </div>
    </div>
    <div id="${id}" class="BusinessesPackDisplayCon3"></div>
  </div>`;
  }
  _listingPack(title, colors, id, actionData = "expandforviewall") {
    return `
  <div class="ListingPackDisplayCon1">
    <div class="ListingPackDisplayCon2">
      <div  style="color: #${colors.packTitles};" class="BusinessesPackDisplayTitle">
        ${title}
      </div>
      <div data-generall="${actionData}"  style="color: #${colors.packTitlesHighlight};" class="BusinessesPackDisplayVerTodo">
        Ver mas
      </div>
    </div>
    <div id="${id}" class="ListingPackDisplayCon3"></div>
  </div>`;
  }


  async _generateBusiness2v(listings, data, listingsConDips = 'flex', isInSellers, own = false, edit = false) {


    let ownOptionDeletedisplayStatus = own ? 'flex' : 'none';
    let ownOptionEditdisplayStatus = edit ? 'flex' : 'none';
    let generalOptionsdisplayStatus = own ? 'none' : 'flex';


    let verifiedHTML = ``;
    let v20BusinessCon10Class = 'v20BusinessCon10'
    if (listingsConDips === 'none') {
      v20BusinessCon10Class = ''
    }
    const userData = firebase._getLatestCurrentUserData()

    let menuDotsHtml = ``;
    if (userData?.businesses?.includes(data.businessId)) {
      menuDotsHtml = `
        <div class="v20BusinessCon7BDots onBusinessOpenEditOptions returnForActionOpenForDisplay openBusinessEditOptionsGlobal">
          <img height="20px" src="${iconDotsMenu}"/>
        </div>
    `;
    }
    let profUrl = data?.profileImg
    let profUrlOrig = data?.profileImg
    let backUrl = data?.backgroundImg
    if (data?.images) {
      profUrl = data?.images?.profile[0]?.res_200
      profUrlOrig = data?.images?.profile[0]?.res_1000
      backUrl = data?.images?.background[0]?.res_500
    }


    const businessHTML = `

        <div
          data-lives="business"
          data-origimg="${profUrlOrig}"
          data-businessId="${data.businessId}"
          class="v20BusinessCon1A ActionOpenForDisplay hasOriginalImages">




              <div class="nvBusinessEachCon6BA">
                <div class="nvBusinessEachCon6B">
                  <div class="nvBusinessEachCon6">
                    <div class="nvBusinessEachCon6Text1">${data.name}</div>
                    <div class="nvBusinessEachCon6Text2">${data.shortDescription}</div>
                  </div>

                  <div class="nvBusinessEachConProfileIMGCon">
                    <img src="${profUrl}" class="nvBusinessEachConProfileIMG ImgForBigDisplay">
                  </div>
                </div>
              </div>




            <div class="v20BusinessCon9">
              <div class="${v20BusinessCon10Class}" style:="display: ${listingsConDips};">
              ${listings}
              </div>
              <div class="v20BusinessCon11">
                <div class="v20BusinessCon12">
                  <div class="v20BusinessCon13">
                    <img height="8px" src="${iconWhiteViews}" />
                    <div class="v20BusinessText6">${GENRALHELPERS._formatNumberShort(
      data.views
    )}</div>
                  </div>
                  <div class="v20BusinessCon13">
                    <img height="8px" src="${iconShares}" />
                    <div class="v20BusinessText6">${GENRALHELPERS._formatNumberShort(
      data.shares
    )}</div>
                  </div>
                </div>


                <div class="v20BusinessCon14" style="display: ${generalOptionsdisplayStatus};">
                  <div class="v20BusinessText7">Ver Empresa</div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M0.75 5.75H10.75M10.75 5.75L5.75 0.75M10.75 5.75L5.75 10.75" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>      

                <div class="v20BusinessCon14Edit returnForActionOpenForDisplay" style="display: ${ownOptionEditdisplayStatus};">
                  <div class="v20BusinessText7Edit">Editar</div>
                  <img height="12px" src="${iconRedEdit}" />
                </div>   

                <div class="v20BusinessCon14Delete returnForActionOpenForDisplay" style="display: ${ownOptionDeletedisplayStatus};">
                  <div class="v20BusinessText7Delete">Eliminar</div>
                  <img height="12px" src="${iconRedDelete}" />
                </div>



              </div>
            </div>
        </div>

    `;

    let finalBusinessHTML = businessHTML;

    if (!isInSellers) {
      finalBusinessHTML = `<div class="nvBusinessVerCon1A">${businessHTML}</div>`
    }

    return finalBusinessHTML;
  }


  async _businessInPack(listings, data) {
    const backImgUrl = data.backgroundImg;
    const ProfileImgUrl = data.profileImg;
    return `
<div
  data-lives="business"
  data-businessId="${data.businessId}"
  class="BusinessInSearchCon1 ActionOpenForDisplay"
>
  <div class="BusinessInSearchCon2">
    <img
      id=""
      class="BusinessInSearchCon1BackgroundImg"
      loading="lazy"
      src="${backImgUrl}"
      alt=""
    >
    <div class="BusinessInSearchCon3">
      <div class="BusinessInSearchCon4">
        <div class="BusinessInSearchCon5">
          <div class="BusinessInSearchCon6">
            <div
              style="color: #${data.colors.headerPrimary};"
              class="BusinessInSearchBusinessName"
            >
              ${data.name}
            </div>
            <div
              style="color: #${data.colors.headerSecondary};"
              class="BusinessInSearchBusinessShortDescription"
            >
              ${data.shortDescription}
            </div>
          </div>
          <div class="BusinessInSearchCon7">
            ${this._generateBusinessRewiewStars(
      data.ratedAt,
      data.numberOfReviews,
      data
    )}
          </div>
        </div>
        <img
          id="BusinessInSearchCon8ProfileImg"
          class="BusinessInSearchCon8 ImgForBigDisplay"
          src="${ProfileImgUrl}"
          loading="lazy"
          alt=""
        >
      </div>
    </div>
  </div>
  <div class="BusinessInSearchCon9 BusinessInSearchCon9B">
    <div class="BusinessInSearchCon10">${listings}</div>
  </div>
</div>
`;
  }
  async _listingHorizontal(data, colors, openToIn, from) {
    if (!data) return ``;
    console.log(data);
    let priceToDisplay = data.listingPrice;
    // const openTo = data.openTo;
    let openTo = "listing";
    if (data.businessId) {
      openTo = "listingInBusiness";
    }

    let priceDescriptionHtml = ``;

    if (data?.listingPriceMarkedAs && data?.listingPriceMarkedAs.length > 1) {
      priceDescriptionHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingHorizontalTextB1"
    >
      precio ${data.listingPriceMarkedAs}
    </div>
    `;
    }
    let itmesAvailableHtml = ``;

    if (data?.listingItemsAvailable && data?.listingItemsAvailable > 0) {
      let textToShow = `${data.listingItemsAvailable} unidades disponibles`;
      if (data.listingItemsAvailable === 1) {
        textToShow = `último disponible`;
      }
      if (data.listingItemsAvailable === 2) {
        textToShow = `solo ${data.listingItemsAvailable} unidades disponibles`;
      }

      itmesAvailableHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingHorizontalTextB2"
    >
       ${textToShow}
    </div>
    `;
    }

    const itemImg = data.listingMainImg;
    // const itemImg = await firebase._getImageUrl(data.listingMainImg);
    let moreImgsHtml = `<img height="16px" src="${moreImg1}" />`;

    if (data.listingImgsIds.length === 2) {
      moreImgsHtml = `<img height="16px" src="${moreImg2}" />`;
    }
    if (data.listingImgsIds.length === 3) {
      moreImgsHtml = `<img height="16px" src="${moreImg3}" />`;
    }
    if (data.listingImgsIds.length === 4) {
      moreImgsHtml = `<img height="16px" src="${moreImg4}" />`;
    }
    if (data.listingImgsIds.length === 5) {
      moreImgsHtml = `<img height="16px" src="${moreImg5}" />`;
    }
    if (data.listingImgsIds.length === 6) {
      moreImgsHtml = `<img height="16px" src="${moreImg6}" />`;
    }

    let showPrice = "$ preguntar";
    let onDiscountTagHtml = "";
    let onDiscountTextHtml = "";
    let itemMarkedAsHtml = "";

    if (data?.listingMarkedAs) {
      itemMarkedAsHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalCon10B"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalTextB3"
          >
            ${data.listingMarkedAs}
          </div>
        </div>
      `;
    }

    if (data.onDiscount && data.listingPriceMarkedAs !== "preguntar") {
      if (!data.onDiscount.amount || parseInt(data.onDiscount.amount) < 1) {
      } else {
        priceToDisplay = data.onDiscount.finalPrice;

        onDiscountTagHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalCon10"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalOnDiscount"
          >
            En oferta ${data.onDiscount.percent}% ↓
          </div>
        </div>
      `;

        onDiscountTextHtml = `
          <div
            style="color: #${colors.itemHighlight};"
            class="ListingVeriticalPriceBeforeText"
            >
            <div class="Antes">Antes</div>
            <div
              style="color: #${colors.itemHighlight};"
              class="ListingVeriticalPriceBeforePrice"
            >
              ${GENRALHELPERS._convertToPrice(
          data.listingPrice,
          data.listingCoin
        )}
            </div>
          </div>
      `;
      }
    }

    if (data.listingPriceMarkedAs !== "preguntar") {
      showPrice = GENRALHELPERS._convertToPrice(
        priceToDisplay,
        data.listingCoin
      );
    }

    return `
<div
  data-openTo="${openTo}"
  data-openfrom="${from}"
  data-listingId="${data.listingId}"
  data-businessId="${data.businessId}"
    class="ListingHorizontalCon1 ActionOpenForDisplay">
  <div class="ListingVirticalCon2ImageB3">
    <img class="ListingHorizontalCon2Image ImgForBigDisplay" src="${itemImg}" loading="lazy">
    <div class="ListingVirticalCon2ImageC">
      ${moreImgsHtml}
    </div>
  </div>
  <div style="background: #${colors.itemBackgroundSecondary};"
       class="ListingHorizontalCon3">
    <div class="ListingHorizontalCon4">
      <div style="background: #${colors.itemBackgroundPrimary
      };" class="ListingHorizontalCon5">
        <div style="color: #${colors.itemTextPrimary
      };" class="ListingVeriticalTitle">
          ${data.listingName}
        </div>
      </div>
      <div style="background: #${colors.itemBackgroundSecondary
      };" class="ListingHorizontalCon6">
        <div class="ListingHorizontalCon7">
          <div class="ListingHorizontalCon8">
            <div class="ListingHorizontalCon9">
              ${onDiscountTagHtml}
              <div class="ListingHorizontalCon9B">
                ${priceDescriptionHtml}
                <div style="color: #${colors.itemTextFour
      };" class="ListingVeriticalPrice">
                  ${showPrice}
                </div>
              </div>
            </div>
            <div style="color: #${colors.itemTextFour
      };" class="ListingVeriticalCondition">
              ${data.listingCondition}
            </div>
            ${itmesAvailableHtml}
            ${itemMarkedAsHtml}
          </div>
          ${onDiscountTextHtml}
        </div>
        <div style="color: #${colors.itemTextSecondary
      };" class="ListingVeriticalDescription">
          ${GENRALHELPERS._shortenText(data.listingDescription, 20)}
        </div>
      </div>
    </div>
    <div class="ListingVerticalCon13B">
      <div class="ListingVerticalCon11">
        <div class="ListingVerticalCon12">
          <div class="ListingDisplayViewsText">${GENRALHELPERS._formatNumberShort(
        data.listingViews
      )}</div>
          <img height="12px" src="${iconBlackViews}" />
          </div>
          </div>
          <div class="ListingVerticalCon14">
          <div class="ListingVerticalText1">Ver artículo</div>
          <img height="8px" src="${iconGreenAhead}" />
      </div>
    </div>
  </div>
</div>
    `;
  }
  async _listingVertical(
    data,
    colors,
    openToIn,
    businessId,
    from,
    fromEdit = "false",
    isForEdit
  ) {
    console.warn(from);


    // return
    const account = firebase._getLatestCurrentUserData();
    let priceToDisplay = data.listingPrice;
    const itemImg = data.listingMainImg;
    // const itemImg = await firebase._getImageUrl(data.listingMainImg);
    // const openTo = data.openTo;
    let openTo = "listing";
    if (data.businessId) {
      openTo = "listingInBusiness";
    }

    let moreImgsHtml = `<img height="20px" src="${moreImg1}" />`;
    let priceDescriptionHtml = ``;

    if (data?.listingPriceMarkedAs && data?.listingPriceMarkedAs.length > 1) {
      priceDescriptionHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingVeriticalTextB1"
    >
      precio ${data.listingPriceMarkedAs}
    </div>
    `;
    }
    let itmesAvailableHtml = ``;

    if (data?.listingItemsAvailable && data?.listingItemsAvailable > 0) {
      let textToShow = `${data.listingItemsAvailable} unidades disponibles`;
      if (data.listingItemsAvailable === 1) {
        textToShow = `último disponible`;
      }
      if (data.listingItemsAvailable === 2) {
        textToShow = `solo ${data.listingItemsAvailable} unidades disponibles`;
      }

      itmesAvailableHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingVeriticalTextB2"
    >
       ${textToShow}
    </div>
    `;
    }

    if (data.listingImgsIds.length === 2) {
      moreImgsHtml = `<img height="20px" src="${moreImg2}" />`;
    }
    if (data.listingImgsIds.length === 3) {
      moreImgsHtml = `<img height="20px" src="${moreImg3}" />`;
    }
    if (data.listingImgsIds.length === 4) {
      moreImgsHtml = `<img height="20px" src="${moreImg4}" />`;
    }
    if (data.listingImgsIds.length === 5) {
      moreImgsHtml = `<img height="20px" src="${moreImg5}" />`;
    }
    if (data.listingImgsIds.length === 6) {
      moreImgsHtml = `<img height="20px" src="${moreImg6}" />`;
    }
    let onDiscountTagHtml = "";
    let onDiscountTextHtml = "";
    let itemMarkedAsHtml = "";

    if (data?.listingMarkedAs) {
      itemMarkedAsHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalCon10B"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalTextB3"
          >
            ${data.listingMarkedAs}
          </div>
        </div>
      `;
    }

    let showPrice = "$ preguntar";

    if (data.onDiscount && data.listingPriceMarkedAs !== "preguntar") {
      if (!data.onDiscount.amount || parseInt(data.onDiscount.amount) < 1) {
      } else {
        priceToDisplay = data.onDiscount.finalPrice;

        onDiscountTagHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalCon10"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalOnDiscount"
          >
            En oferta ${data.onDiscount.percent}% ↓
          </div>
        </div>
      `;

        onDiscountTextHtml = `
          <div
            style="color: #${colors.itemHighlight};"
            class="ListingVeriticalPriceBeforeText"
            >
            <div class="Antes">Antes</div>
            <div
              style="color: #${colors.itemHighlight};"
              class="ListingVeriticalPriceBeforePrice"
            >
              ${GENRALHELPERS._convertToPrice(
          data.listingPrice,
          data.listingCoin
        )}
            </div>
          </div>
      `;
      }
    }

    if (data.listingPriceMarkedAs !== "preguntar") {
      showPrice = GENRALHELPERS._convertToPrice(
        priceToDisplay,
        data.listingCoin
      );
    }

    let menuDotsHtml = ``;
    if (data.businessId) {
      if (account?.business === data.businessId)
        menuDotsHtml = `
        <div class="OwnBusinessListingButtonMenu returnForActionOpenForDisplay openListingEditOptionsGlobal">
          <img height="20px" src="${iconDotsMenu}"/>
        </div>
    `;
    }

    return `
<div
  data-openTo="${openTo}"
  data-openfrom="${from}"
  data-openfromedit="${fromEdit}"
  data-listingId="${data.listingId}"
  data-businessId="${data.businessId}"
  class="ListingVeriticalCon1 ActionOpenForDisplay"
>
  <div class="ListingVirticalCon2ImageB">
    <img class="ListingVirticalCon2Image ImgForBigDisplay" src="${itemImg}" loading="lazy">
    ${menuDotsHtml}
    <div class="ListingVirticalCon2ImageC">
    ${moreImgsHtml}
    </div>
  </div>
  <div
    style="background: ${GENRALHELPERS._hexToRgba(
      colors.itemBackgroundSecondary,
      0.8
    )}"
    class="ListingVeriticalCon3"
  >
    <div class="ListingVeriticalCon4">
      <div
        style="background: #${colors.itemBackgroundPrimary};"
        class="ListingVeriticalCon5"
      >
        <div style="color: #${colors.itemTextPrimary
      };" class="ListingVeriticalTitle">
          ${data.listingName}
        </div>
      </div>
      <div class="ListingVeriticalCon6">
        <div class="ListingVeriticalCon7">
          <div class="ListingVeriticalCon8">
            <div class="ListingVeriticalCon9">
              ${onDiscountTagHtml}
              <div class="ListingVeriticalCon9B">
                ${priceDescriptionHtml}
                <div
                  style="color: #${colors.itemTextFour};"
                  class="ListingVeriticalPrice"
                >
                  ${showPrice}
                </div>
              </div>
            </div>
            <div
              style="color: #${colors.itemTextFour};"
              class="ListingVeriticalCondition"
            >
              ${data.listingCondition}
            </div>
            ${itmesAvailableHtml}
            ${itemMarkedAsHtml}
          </div>
         ${onDiscountTextHtml}
        </div>
        <div
          style="color: #${colors.itemTextSecondary};"
          class="ListingVeriticalDescription"
        >
          ${GENRALHELPERS._shortenText(data.listingDescription, 30)}
        </div>
      </div>
    </div>


<div class="ListingVerticalCon13">
  <div class="ListingVerticalCon11">
    <div class="ListingVerticalCon12">
      <div class="ListingDisplayViewsText">${GENRALHELPERS._formatNumberShort(
        data.listingViews
      )}</div>
      <img height="12px" src="${iconBlackViews}" />
      </div>
      </div>
      <div class="ListingVerticalCon14">
      <div class="ListingVerticalText1">Ver artículo</div>
      <img height="8px" src="${iconGreenAhead}" />
  </div>
</div>`;
  }

  _listingVerticalNV(
    data,
    isInRecent,
    from = '',
    isInBusiness,
    deleteOnly = false
  ) {
    const account = firebase._getLatestCurrentUserData();


    let priceToDisplay = data.listingPrice;

    let lives = 'seller'
    let isInRecentClass = ''
    let isMiniTitleClass = ''
    let isPriceMiniClass = ''

    let displayHiddenForMini = 'flex'

    if (isInRecent) {
      isInRecentClass = 'nvListingVerCon1InRecent'
    }

    if (isInBusiness) {
      isInRecentClass = 'nvListingVerCon1InBusiness'
      isMiniTitleClass = 'nvListingVerText2Mini'
      displayHiddenForMini = 'none'
      isPriceMiniClass = 'nvListingVerText6Mini'
    }



    if (data.businessId) {
      lives = 'business'
    }

    let priceDescriptionHtml = ``;

    if (data?.listingPriceMarkedAs && data?.listingPriceMarkedAs.length > 1) {
      priceDescriptionHtml = `
        <div class="nvListingVerText5">• precio ${data.listingPriceMarkedAs}</div>
    `;
    }


    let itmesAvailableHtml = ``;
    if (data?.listingItemsAvailable && data?.listingItemsAvailable > 0) {
      let textToShow = `• ${data.listingItemsAvailable} unidades disponibles`;
      if (data.listingItemsAvailable === 1) {
        textToShow = `• último disponible`;
      }
      if (data.listingItemsAvailable === 2) {
        textToShow = `• solo ${data.listingItemsAvailable} unidades disponibles`;
      }

      itmesAvailableHtml = `
          <div class="nvListingVerText7">${textToShow}</div>
        `;
    }

    let itemConditionHtml = ``;
    if (data?.listingCondition) {
      itemConditionHtml = `
      <div class="nvListingVerText12">• ${data.listingCondition}</div>
    `;
    }

    let onDiscountTagHtml = "";
    let onDiscountTextHtml = "";
    let itemMarkedAsHtml = "";

    if (data?.listingMarkedAs) {
      itemMarkedAsHtml = `
          <div class="nvListingVerText8">• ${data.listingMarkedAs}</div>
      `;
    }

    let showPrice = "$ preguntar";

    if (data.onDiscount && data.listingPriceMarkedAs !== "preguntar") {
      if (!data.onDiscount.amount || parseInt(data.onDiscount.amount) < 1) {
      } else {
        priceToDisplay = data.onDiscount.finalPrice;

        onDiscountTagHtml = `
          <div class="nvListingVerCon20" style="display: ${displayHiddenForMini}">
            <div class="nvListingVerText4">En oferta ${data.onDiscount.percent}% ↓</div>
          </div>
      `;

        onDiscountTextHtml = `
          <div class="nvListingVerCon25" style="display: ${displayHiddenForMini}">
            <div class="nvListingVerText9">Antes</div>
            <div class="nvListingVerText10">${GENRALHELPERS._convertToPrice(
          data.listingPrice,
          data.listingCoin
        )}
            </div>
          </div>
        `;
      }
    }

    if (data.listingPriceMarkedAs !== "preguntar") {
      showPrice = GENRALHELPERS._convertToPrice(
        priceToDisplay,
        data.listingCoin
      );
    }

    let menuDotsHtml = ``;
    const generateAdminPrivilegedHtml = () => {

      if (!account) return
      if (data?.businessId) {
        function accountHasBusiness(account, businessId) {
          if (!account || !account.businesses) return false;

          return account.businesses.some(business => business.id === businessId);
        }
        if (!accountHasBusiness(account, data.businessId)) {
          console.log('here');
          return
        }
      } else {
        if (data.sellerId !== account.userId) {
          console.log('here');
          return
        }
      }

      if (!isInBusiness) {
        menuDotsHtml = `
                <div class="nvListingVerCon3Dots returnForActionOpenForDisplay openListingEditOptionsGlobal">
                  <img height="20px" src="${iconDotsMenu}"/>
                </div>
            `;
      }

    }

    generateAdminPrivilegedHtml()

    let allImgs = ``;

    // data.listingImgsIds.forEach(img => {
    //   allImgs += `
    //   <div class="nvListingVerCon8">
    //     <img class="nvListingVerCon8Img" src="${img}">
    //   </div>
    //   `
    // });


    let img1Display = 'flex'
    let img2Class = 'nvListingVerCon2Bg'

    if (isInBusiness) {
      // img1Display = 'none'
      img2Class = 'nvListingVerCon2ImgNoBlur'
    }

    // let from = ''

    // if (data.businessId) {
    //   from = 'business'
    // }

    let imageBig = data.listingMainImg
    let imageBlurred = data.listingMainImg

    if (!data.listingMainImg) {

      if (isInRecent) {
        imageBig = data.listingImgsIds[0].res_500
      } else {
        imageBig = data.listingImgsIds[0].res_200
      }
      imageBlurred = data.listingImgsIds[0].res_blurred


      data.listingImgsIds.forEach(img => {
        allImgs += `
      <div class="nvListingVerCon8">
        <img class="nvListingVerCon8Img" src="${img.res_20}">
      </div>
      `
      });


    }

    let businessLogo = ``
    if (lives === 'business' && from !== 'business' && !isInBusiness) {
      businessLogo = `<img class="nvListingVerCon4" height="32px" src="${logoBusiness}"></img>`
    }

    let videoHtml = ``

    if (data.videoUrl) {
      videoHtml = `
        <div class="nvListingVerCon7">
          <img class="nvListingVerCon7Icon" height="12px" src="${iconHomeCatVideos}" />
        </div>
       `
    }



    let originalImages = data.listingImgsIds
    if (data?.listingImgsIds?.[0]?.res_200) {
      let orgImgs = []
      data.listingImgsIds.forEach(img => {
        orgImgs.push(img.res_1000 || img.res_500);
      })
      originalImages = orgImgs
    }


    const curAcc = firebase._getLatestCurrentUserData()
    console.log('DATA HERE', data, 'curAcc', curAcc);



    const getAdminNotes = () => {
      let adminNotesHtml = "";

      if (isInBusiness) return adminNotesHtml
      if (!curAcc || !data?.adminNotes) return adminNotesHtml

      const isBusinessAdmin =
        data.businessId &&
        Array.isArray(curAcc?.businesses) &&
        curAcc.businesses.some((business) => {
          const hasMatchingBusiness = business?.id === data.businessId;
          const hasAllowedRole =
            business?.role === "owner" || business?.role === "admin";

          return hasMatchingBusiness && hasAllowedRole;
        });

      const isListingSeller =
        !data.businessId &&
        data.sellerId === curAcc?.userId;

      if (!isBusinessAdmin && !isListingSeller) return adminNotesHtml

      adminNotesHtml = `
          <div class="nvListingEachAdminNotesCon1LisVer">
            <div class="nvListingEachAdminNotesCon3LisVer">
              <div class="nvListingEachAdminNotesText1LisVer">Notas admin</div>
            </div>

            <div class="nvListingEachAdminNotesCon4LisVer">
              <div class="nvListingEachAdminNotesText2LisVer">${data.adminNotes}</div>
            </div>
          </div>
        `;

      return adminNotesHtml
    };

    const listingHtml = `
        <div
         data-origimg="${originalImages.join("°-°|°-°?°-°|°-°")}"
          data-lives="${lives}"
          data-deleteonly="${deleteOnly}"
          data-from="${from}"
          data-listingId="${data.listingId}"
          data-businessId="${data.businessId}"
          data-sellerId="${data.sellerId}"
          data-mainimgurl="${data.listingMainImg}"

          class="nvListingVerCon1 ${isInRecentClass} ActionOpenForDisplayListing hasOriginalImages">

          <div class="nvListingVerCon2">
            <img class="nvListingVerCon2Img ImgForBigDisplay" style="display: ${img1Display}" src="${imageBig}">
            <img class="${img2Class} ImgForBigDisplay" src="${imageBlurred}">
            <div class="nvListingVerCon3">
              ${businessLogo}
            </div>
            ${menuDotsHtml}
            <div class="nvListingVerCon5">
              <div class="nvListingVerCon6">
                ${videoHtml}
                ${allImgs}
              </div>
              <div class="nvListingVerCon9">
                <div class="nvListingVerCon10">
                  <div class="nvListingVerCon11">
                    <div class="nvListingVerText1">${GENRALHELPERS._formatNumberShort(data.listingViews)}</div>
                    <img height="6px" src="${iconWhiteViews}" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nvListingVerCon12">
            <div class="nvListingVerCon13">
              <div class="nvListingVerCon14">
                <div class="nvListingVerText2 ${isMiniTitleClass}">${data.listingName}</div>
              </div>
              <div class="nvListingVerCon15" style="display: ${displayHiddenForMini}">
                <div class="nvListingVerText3">${data.listingDescription}</div>
              </div>
            </div>
            <div class="nvListingVerCon16">
              <div class="nvListingVerCon17">
                <div class="nvListingVerCon18">
                  <div class="nvListingVerCon19">
                    ${onDiscountTagHtml}

                    <div class="nvListingVerCon21">
                      <div class="nvListingVerText6 ${isPriceMiniClass}">${showPrice}</div>
                    </div>
                  </div>
                  <div class="nvListingVerCon22" style="display: ${displayHiddenForMini}">
                    ${itemConditionHtml}
                    ${itemMarkedAsHtml}
                    ${itmesAvailableHtml}
                    ${priceDescriptionHtml}
                  </div>
                </div>
                <div class="nvListingVerCon24">
                  ${onDiscountTextHtml}
                </div>
              </div>
            </div>
            ${getAdminNotes()}
          </div>
        </div>
  `

    let finalHtml = ''


    if (isInBusiness) {
      finalHtml = listingHtml
    } else {
      finalHtml = `<div class="nvListingVerCon1A">${listingHtml}</div>`
    }



    return finalHtml
  }

  async _listingVerticalMini(data, colors, openToIn, businessId, from) {

    return this._listingVerticalNV(data, null, null, true)
    let priceToDisplay = data.listingPrice;
    const itemImg = data.listingMainImg;
    // const itemImg = await firebase._getImageUrl(data.listingMainImg);
    // const openTo = data.openTo;
    let openTo = "listing";
    if (data.businessId) {
      openTo = "listingInBusiness";
    }

    let onDiscountTagHtml = "";
    let onDiscountTextHtml = "";

    let showPrice = "$ preguntar";

    if (data.onDiscount && data.listingPriceMarkedAs !== "preguntar") {
      if (!data.onDiscount.amount || parseInt(data.onDiscount.amount) < 1) {
      } else {
        priceToDisplay = data.onDiscount.finalPrice;
        console.log(data.listingName);

        onDiscountTagHtml = `
              <div style="background: #${colors.itemHighlight};" class="ListingMiniVeriticalCon10">
                <div style="color: #${colors.itemHighlightText};" class="ListingVeriticalOnDiscount">
                  En oferta ${data.onDiscount.percent}% ↓
                </div>
              </div>
      `;

        onDiscountTextHtml = `
          <div
            style="color: #${colors.itemHighlight};"
            class="ListingVeriticalPriceBeforeText"
            >
            <div class="Antes">Antes</div>
            <div
              style="color: #${colors.itemHighlight};"
              class="ListingVeriticalPriceBeforePrice"
            >
              ${GENRALHELPERS._convertToPrice(
          data.listingPrice,
          data.listingCoin
        )}
            </div>
          </div>
      `;
      }
    }

    if (data.listingPriceMarkedAs !== "preguntar") {
      showPrice = GENRALHELPERS._convertToPrice(
        priceToDisplay,
        data.listingCoin
      );
    }

    return `
  <div
      data-openTo="${openTo}"
      data-openfrom="${from}"
      data-listingId="${data.listingId}"
      data-businessId="${data.businessId}"
      class="ListingMiniVeriticalCon1 ActionOpenForDisplay">
  <img class="ListingMiniVeriticalCon2Image ImgForBigDisplay" src="${itemImg}" loading="lazy">
  <div  style="background: ${GENRALHELPERS._hexToRgba(
      colors.itemBackgroundSecondary,
      0.8
    )};" class="ListingMiniVeriticalCon3">
    <div class="ListingMiniVeriticalCon4">
      <div style="background: #${colors.itemBackgroundPrimary
      };" class="ListingMiniVeriticalCon5">
        <div style="color: #${colors.itemTextPrimary
      };" class="ListingVeriticalTitleMini">
          ${data.listingName}
        </div>
      </div>
      <div class="ListingMiniVeriticalCon6">
        <div class="ListingMiniVeriticalCon7">
          <div class="ListingMiniVeriticalCon8">
            <div class="ListingMiniVeriticalCon9">
             ${onDiscountTagHtml}
              <div style="color: #${colors.itemTextFour
      };" class="ListingVeriticalPriceMini">
              ${showPrice}
              </div>
            </div>
            <div style="color: #${colors.itemTextFour
      };" class="ListingVeriticalConditionMini">
              ${data.listingCondition}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ListingVerticalCon13MiniV2">
      <div class="ListingVerticalCon11MiniV2">
        <div class="ListingVerticalCon12MiniV2">
          <div class="ListingDisplayViewsTextMiniV2">${GENRALHELPERS._formatNumberShort(
        data.listingViews
      )}</div>
          <img height="6px" src="${iconBlackViews}" />
          </div>
          </div>
          <div class="ListingVerticalCon14MiniV2">
          <div class="ListingVerticalText1MiniV2">Ver artículo</div>
          <img height="6px" src="${iconGreenAhead}" />
      </div>
    </div>
  </div>
</div>
    `;
  }

  _viewAllListingsMini(colors) {
    return `
<div class="ListingMiniVeriticalCon3B" style="background: ${GENRALHELPERS._hexToRgba(
      colors.itemBackgroundSecondary,
      0.8
    )};">
  <div class="ListingMiniVeriticalCon5" style="background: #${colors.itemBackgroundPrimary
      };">
    <div style="color: #${colors.itemTextPrimary
      };" class="ListingVeriticalTitleMini">Visita este negocio</div>
  </div>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 49" fill="none">
  <path d="M24 0.5C24.8302 0.5 25.6265 0.829812 26.2135 1.41688C26.8006 2.00395 27.1304 2.80019 27.1304 3.63043V21.3696H44.8696C45.6998 21.3696 46.496 21.6994 47.0831 22.2864C47.6702 22.8735 48 23.6698 48 24.5C48 25.3302 47.6702 26.1265 47.0831 26.7135C46.496 27.3006 45.6998 27.6304 44.8696 27.6304H27.1304V45.3696C27.1304 46.1998 26.8006 46.996 26.2135 47.5831C25.6265 48.1702 24.8302 48.5 24 48.5C23.1698 48.5 22.3735 48.1702 21.7864 47.5831C21.1994 46.996 20.8696 46.1998 20.8696 45.3696V27.6304H3.13043C2.30019 27.6304 1.50395 27.3006 0.916883 26.7135C0.329812 26.1265 0 25.3302 0 24.5C0 23.6698 0.329812 22.8735 0.916883 22.2864C1.50395 21.6994 2.30019 21.3696 3.13043 21.3696H20.8696V3.63043C20.8696 2.80019 21.1994 2.00395 21.7864 1.41688C22.3735 0.829812 23.1698 0.5 24 0.5Z" fill="#${colors.itemBackgroundPrimary
      }"/>
</svg>
  <div class="ListingMiniVeriticalCon5" style="background: #${colors.itemBackgroundPrimary
      };">
    <div style="color: #${colors.itemTextPrimary
      };"  class="ListingVeriticalTitleMini">Para ver todos los listados</div>
  </div>
</div>`;
  }

  _listingVerticalMiniNoListings(individual, messageIn) {
    let message =
      "Este negocio no tiene listados en este momento. Regrese pronto.";

    if (individual) {
      message = "No hay listados aqui.";
    }
    if (messageIn) {
      message = messageIn;
    }
    return `
  <div class="NoListingsMiniCon1">
    <div class="NoListingsMiniTitle">
      Sin listados...
    </div>
  </div>
    `;
  }

  async _listingVerticalBig(data, colors, openToIn, businessId, from) {
    let priceToDisplay = data.listingPrice;
    const itemImg = data.listingMainImg;
    // let businessIdToUse = "nothing";
    // const itemImg = await firebase._getImageUrl(data.listingMainImg);
    // const openTo = data.openTo;
    let openTo = "listing";
    if (data.businessId) {
      openTo = "listingInBusiness";
    }

    let priceDescriptionHtml = ``;

    if (data?.listingPriceMarkedAs && data?.listingPriceMarkedAs.length > 1) {
      priceDescriptionHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingVeriticalBigTextB1"
    >
      • precio ${data.listingPriceMarkedAs}
    </div>
    `;
    }
    let itmesAvailableHtml = ``;

    if (data?.listingItemsAvailable && data?.listingItemsAvailable > 0) {
      let textToShow = `• ${data.listingItemsAvailable} unidades disponibles`;
      if (data.listingItemsAvailable === 1) {
        textToShow = `• último disponible`;
      }
      if (data.listingItemsAvailable === 2) {
        textToShow = `• solo ${data.listingItemsAvailable} unidades disponibles`;
      }
      itmesAvailableHtml = `
      <div
      style="color: #${colors.itemHighlight};"
      class="ListingVeriticalBigTextB2"
    >
      ${textToShow}
    </div>
    `;
    }

    let moreImgsHtml = `<img height="20px" src="${moreImg1}" />`;

    if (data.listingImgsIds.length === 2) {
      moreImgsHtml = `<img height="20px" src="${moreImg2}" />`;
    }
    if (data.listingImgsIds.length === 3) {
      moreImgsHtml = `<img height="20px" src="${moreImg3}" />`;
    }
    if (data.listingImgsIds.length === 4) {
      moreImgsHtml = `<img height="20px" src="${moreImg4}" />`;
    }
    if (data.listingImgsIds.length === 5) {
      moreImgsHtml = `<img height="20px" src="${moreImg5}" />`;
    }
    if (data.listingImgsIds.length === 6) {
      moreImgsHtml = `<img height="20px" src="${moreImg6}" />`;
    }

    let showPrice = "$ preguntar";
    let onDiscountTagHtml = "";
    let onDiscountTextHtml = "";
    let itemMarkedAsHtml = "";

    if (data?.listingMarkedAs) {
      itemMarkedAsHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalBigCon10B"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalBigTextB3"
          >
            • ${data.listingMarkedAs}
          </div>
        </div>
      `;
    }

    if (data.onDiscount && data.listingPriceMarkedAs !== "preguntar") {
      if (!data.onDiscount.amount || parseInt(data.onDiscount.amount) < 1) {
      } else {
        priceToDisplay = data.onDiscount.finalPrice;
        onDiscountTagHtml = `
        <div
          style="background: #${colors.itemHighlight};"
          class="ListingVeriticalBigCon10"
          >
          <div
            style="color: #${colors.itemHighlightText};"
            class="ListingVeriticalBigOnDiscount"
          >
            En oferta ${data.onDiscount.percent}% ↓
          </div>
        </div>
      `;

        onDiscountTextHtml = `
          <div
            style="color: #${colors.itemHighlight};"
            class="ListingVeriticalBigPriceBeforeText"
            >
            <div class="Antes">Antes</div>
            <div
              style="color: #${colors.itemHighlight};"
              class="ListingVeriticalBigPriceBeforePrice"
            >
              ${GENRALHELPERS._convertToPrice(
          data.listingPrice,
          data.listingCoin
        )}
            </div>
          </div>
      `;
      }
    }

    if (data.listingPriceMarkedAs !== "preguntar") {
      showPrice = GENRALHELPERS._convertToPrice(
        priceToDisplay,
        data.listingCoin
      );
    }
    return `
<div
  data-openTo="${openTo}"
  data-openfrom="${from}"
  data-listingId="${data.listingId}"
  data-businessId="${data.businessId}"
  class="ListingVeriticalBigCon1 ActionOpenForDisplay"
>
  <div class="ListingVirticalCon2ImageB2">
    <img class="ListingVirticalBigCon2Image ImgForBigDisplay" src="${itemImg}" loading="lazy">
    <div class="ListingVirticalCon2ImageC">
      ${moreImgsHtml}
    </div>
  </div>
  <div
    style="background: #${colors.itemBackgroundSecondary}; "
    class="ListingVeriticalBigCon3"
  >
    <div class="ListingVeriticalBigCon4">
      <div
        style="background: #${colors.itemBackgroundPrimary};"
        class="ListingVeriticalBigCon5"
      >
        <div style="color: #${colors.itemTextPrimary
      };" class="ListingVeriticalBigTitle">
          ${data.listingName}
        </div>
      </div>
      <div class="ListingVeriticalBigCon6">
        <div class="ListingVeriticalBigCon7">
          <div class="ListingVeriticalBigCon8">
            <div class="ListingVeriticalBigCon9">
              ${onDiscountTagHtml}
              <div class="ListingVeriticalBigCon9B">
                ${priceDescriptionHtml}
                <div
                  style="color: #${colors.itemTextFour};"
                  class="ListingVeriticalBigPrice"
                >
                  ${showPrice}
                </div>
              </div>
            </div>
            <div
              style="color: #${colors.itemTextFour};"
              class="ListingVeriticalBigCondition"
            >
              ${data.listingCondition}
            </div>
            ${itmesAvailableHtml}
            ${itemMarkedAsHtml}
          </div>
         ${onDiscountTextHtml}
        </div>
        <div
          style="color: #${colors.itemTextSecondary};"
          class="ListingVeriticalBigDescription"
        >
          ${GENRALHELPERS._shortenText(data.listingDescription, 20)}
        </div>
      </div>
    </div>
    <div class="ListingVeriticalBigCon12">
      <div class="ListingDisplayBigDateCon">
        <p
          class="ListingDisplayBigDateText"
        >
          ${GENRALHELPERS._convertServerTimestampToReadableTime(data.updatedAt)}
        </p>
      </div>
      <div class="ListingMiniVeriticalBigCon12">
        <div
          class="ListingDisplayBigViewsText"
        >
          ${GENRALHELPERS._formatNumberShort(data.listingViews)}
        </div>
          <img height="12px" src="${iconBlackViews}" />
      </div>
      <div class="listingveriticalcon1b">
        <div class="listingveriticaltext1b">Ver artículo</div>
        <div class="listingveriticalcon1b">
          <img height="12px" src="${iconGreenAhead}" />
        </div>
      </div>
    </div>
  </div>
</div>

    `;
  }
}
export default new GenarateHtml();
